module.exports = __webpack_public_path__ + "assets/img/btn3-page.7f3b105a.png";